import { render, staticRenderFns } from "./CampaignMultiselect.vue?vue&type=template&id=ab4049fa"
import script from "./CampaignMultiselect.vue?vue&type=script&lang=js"
export * from "./CampaignMultiselect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports